import React from 'react';
import {
  DialogTitle,
  DialogActions,
  Typography,
  Divider,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import infoIcon from '@src/assets/icons/info.png';
import warningIcon from '@src/assets/icons/warning.svg';

import { StyledDialog } from './index.style';

const NotificationDialogV2 = ({
  name,
  title,
  description,
  variant = 'info', // info | warning
  open,
  width,
  actionComponent,
  onClose,
  showIcon = true,
}) => {
  const renderIcon = () => {
    switch (variant) {
      case 'info':
        return infoIcon;
      case 'warning':
        return warningIcon;
      default:
        return null;
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') return;
    onClose(name);
  };

  return (
    <StyledDialog key={name} open={open} width={width} onClose={handleClose}>
      <div className="dialog-wrapper">
        <div className="header">
          <div className="dialog-title">
            {showIcon && <img src={renderIcon()} alt="icon" className="icon" />}
            <Typography className="title">{title}</Typography>
          </div>

          <IconButton onClick={handleClose} aria-label="delete">
            <Close />
          </IconButton>
        </div>
        <Divider />

        <div className="content-wrapper">
          <DialogTitle classes={{ root: 'dialog-message' }}>
            <div
              className="description"
              // TODO: fix dangerouslySetInnerHTML
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </DialogTitle>

          {actionComponent && (
            <DialogActions classes={{ root: 'dialog-action' }}>
              {actionComponent}
            </DialogActions>
          )}
        </div>
      </div>
    </StyledDialog>
  );
};

export default NotificationDialogV2;
